import React, { FC } from "react";

import { LabelContainer, LabelInsideContainer } from "./Label.styled";
import { ILabelFieldsetProps } from '../../../../interfaces/ui/uiInfo'
import { CSSProperties } from "styled-components";

export interface IProps extends ILabelFieldsetProps {
  isRequired?: boolean;
  supLabel?: JSX.Element;
  content?: string | JSX.Element;
  before?: JSX.Element;
  style?: CSSProperties
}

export const Label: FC<IProps> = ({
                                    supLabel,
                                    isUpperCase = true,
                                    color,
                                    label,
                                    isRequired,
                                    content,
                                    size,
                                    textAlign,
                                    before,
                                    style
                                  }) => {
  return (
    <LabelContainer style={style} $isUpperCase={isUpperCase} color={color} size={size} $textAlign={textAlign}>
      <LabelInsideContainer>
        <div>{label}{supLabel}{isRequired && <span>*</span>}</div>
        {before}
      </LabelInsideContainer>
      {content}
    </LabelContainer>
  )
}